export const signature = {
  add: 'Click to sign',
  remove: 'Remove signature',
  name: 'Name',
  date: 'Date',
};
